module.exports = __webpack_public_path__ + "static/carousel-background-mobile-fb213f926b7b55fc738b8a2dd16d010f.jpg";